import { type FC } from 'react';

import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { NewProjectCard } from '$/components/core/Projects/components/Cards/NewProjectCard';
import { UpgradeAccountCard } from '$/components/core/Projects/components/Cards/UpgradeAccountCard';
import { ProjectCard } from '$/components/core/Projects/ProjectCard';
import { type ProjectOverviewItem } from '$/services/usecases/projects/mapper/projectOverview';

interface Props {
  items: ProjectOverviewItem[];
  hideNewProjectButton?: boolean;
  folderId?: string;
}

export const ProjectGridItems: FC<Props> = ({
  items,
  hideNewProjectButton = false,
  folderId,
}) => {
  const { canCreateMoreProjects } = useAuthorization();

  const projects = items.map((project) => (
    <ProjectCard key={project.id} project={project} />
  ));

  if (items.length === 0 && !hideNewProjectButton) {
    return <NewProjectCard folderId={folderId} />;
  }

  if (!canCreateMoreProjects()) {
    return [...projects, <UpgradeAccountCard key='upgrade-card' />];
  }

  return projects;
};
